export enum OnboardingSubItemKey {
  'schedule_event' = 'schedule_event',
  'create_task' = 'create_task',
  'personal_hub' = 'personal_hub',
  'activity_hobby' = 'activity_hobby',
  'work_hub' = 'work_hub',
  'work_meeting' = 'work_meeting',
  'education_hub' = 'education_hub',
  'education_note' = 'education_note',
  'add_checklist' = 'add_checklist',
  'property_hub' = 'property_hub',
  'utility_payment' = 'utility_payment',
  'garage_hub' = 'garage_hub',
  'vehicle_payment' = 'vehicle_payment',
  'pets_hub' = 'pets_hub',
  'vet_appointment' = 'vet_appointment',
  'payment' = 'payment',
  'bank_account' = 'bank_account',
  'credit_score' = 'credit_score',
  'first_contact' = 'first_contact',
  'google_sync' = 'google_sync',
}
